import React, { useContext } from "react";
import UserContext from "contexts/UserContext";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { colors } from "@utils/styles";
import DynamicLink from "@components/Reusables/DynamicLink";
import Title from "@components/Reusables/Title";
import Text from "@components/Reusables/Text";
import ButtonGroup from "@components/Reusables/ButtonGroup";
import { LoginLink } from "@components/Header/components";
import { parseDate, checkIsPromoted } from "utils/helpers";
export default function useJournalAuth(post) {
	const { userData: user } = useContext(UserContext);

	let articleAccessClass = "";
	let ctaMessage = false;
	//Default show

	function lowercaseFirstLetter(string) {
		return string.charAt(0).toLowerCase() + string.slice(1);
	}

	function journalAccess(salesforceSubscriberField, memberBenefit, user) {
		salesforceSubscriberField = lowercaseFirstLetter(salesforceSubscriberField); //thanks dotnet

		return (
			(salesforceSubscriberField && !user[salesforceSubscriberField]) === true &&
			(memberBenefit ? !user.isMember : true) === true
		);
	}

	const today = parseDate(new Date().toLocaleDateString());
	// const promoDateStart = post.promoDate ? parseDate(post.promoDate) : {};
	// const promoDateEnd = post.promoDateEnd ? parseDate(post.promoDateEnd) : promoDateStart;

	const isPromoted = checkIsPromoted(post.promoDate, post.promoDateEnd);

	const isPromoDate = post.promoDate && isPromoted;
	const is50Resources = post.is50ArticleResources;

	articleAccessClass = "show-article";
	if (post.free || isPromoDate || is50Resources) {
		articleAccessClass = "show-article";
	} else {
		if (!user) {
			articleAccessClass = "clip-article";

			if (post.journalEdition?.journal?.title == "Journal of Medical Practice Management") {
				ctaMessage = (
					<CtaMessage
						title1={<>This article is available to AAPL Members.</>}
						btn1Text={"Become a Member now for full access"}
						btn1Link={`${process.env.APP_URL}/membership/join`}
						btn2Text={"Learn More About JMPM"}
						btn2Link={"/publications/jmpm"}
					/>
				);
			} else if (post.journalEdition?.journal?.title == "Physician Leadership Journal") {
				ctaMessage = (
					<CtaMessage
						title1={<>This article is available to AAPL Members.</>}
						btn1Text={"Become a Member now for full access"}
						btn1Link={`${process.env.APP_URL}/membership/join`}
						btn2Text={"Learn More About PLJ"}
						btn2Link={"/publications/plj"}
					/>
				);
			} else if (
				post.journalEdition?.journal?.title == "Healthcare Administration Leadership & Management Journal"
			) {
				ctaMessage = (
					<CtaMessage
						title1={<>This article is available to AAPL Members.</>}
						btn1Text={"Become a Member now for full access"}
						btn1Link={`${process.env.APP_URL}/membership/join`}
						btn2Text={"Learn More About HALMJ"}
						btn2Link={"/publications/halmj"}
					/>
				);
			} else {
				//This is a fall back for a white paper which has no journal
				ctaMessage = (
					<CtaMessage
						title1={<>This article is available to AAPL Members.</>}
						btn1Text={"Become a Member now for full access"}
						btn1Link={`${process.env.APP_URL}/membership/join`}
						// btn2Text={"Learn More About HALMJ"}
						// btn2Link={"/publications/halmj"}
					/>
				);
			}
		} else if (post.journalEdition?.journal?.title == "Journal of Medical Practice Management") {
			let { salesforceSubscriberField, memberBenefit } = post.journalEdition?.journal;

			salesforceSubscriberField = lowercaseFirstLetter(salesforceSubscriberField); //thanks dotnet
			if (journalAccess(salesforceSubscriberField, memberBenefit, user)) {
				articleAccessClass = "clip-article";

				ctaMessage = (
					<CtaMessage
						title1={
							<>
								This article is available to Subscribers of{" "}
								<DynamicLink color={colors.lightBlue} href="/publications/jmpm" text=" JMPM" />.
							</>
						}
						withLogin={false}
						// btn1Text={"Become a Member now for full access"}
						// btn1Link={`${process.env.APP_URL}/membership/join`}
						// btn2Text={"Subscribe to just the PLJ"}
						// btn2Link={"/publications/subscriptions/physician-leadership-journal-subscription"}
					/>
				);
			}
		} else if (post.journalEdition?.journal?.title == "Physician Leadership Journal") {
			let { salesforceSubscriberField, memberBenefit } = post.journalEdition?.journal;

			if (journalAccess(salesforceSubscriberField, memberBenefit, user)) {
				articleAccessClass = "clip-article";

				ctaMessage = (
					<CtaMessage
						title1={
							<>
								This article is available to AAPL Members and Subscribers of{" "}
								<DynamicLink color={colors.lightBlue} href="/publications/plj" text=" PLJ" />.
							</>
						}
						withLogin={false}
						btn1Text={"Become a Member now for full access"}
						btn1Link={`${process.env.APP_URL}/membership/join`}
						btn2Text={"Subscribe to just the PLJ"}
						btn2Link={"/publications/subscriptions/physician-leadership-journal-subscription"}
					/>
				);
			}
		} else if (post.journalEdition?.journal?.title == "Healthcare Administration Leadership & Management Journal") {
			let { salesforceSubscriberField, memberBenefit } = post.journalEdition?.journal;

			if (journalAccess(salesforceSubscriberField, memberBenefit, user)) {
				articleAccessClass = "clip-article";

				ctaMessage = (
					<CtaMessage
						title1={<>This article is available to AAPL Members.</>}
						withLogin={false}
						btn1Text={"Become a Member now for full access"}
						btn1Link={`${process.env.APP_URL}/membership/join`}
						btn2Text={"Learn More About HALMJ"}
						btn2Link={"/publications/halmj"}
					/>
				);
			} else {
				articleAccessClass = "show-article";
			}
		} else {
			if (user.isMember) {
				//This will show an article that isn't part of any journal
				// to a user who is a member
				articleAccessClass = "show-article";
			} else {
				articleAccessClass = "clip-article";

				ctaMessage = (
					<CtaMessage
						title1={<>This article is available to AAPL Members.</>}
						withLogin={false}
						btn1Text={"Become a Member now for full access"}
						btn1Link={`${process.env.APP_URL}/membership/join`}
						// btn2Text={"Learn More About HALMJ"}
						// btn2Link={"/publications/halmj"}
					/>
				);
			}
		}
	}

	const ShowArticleAccessDenied = !ctaMessage ? null : (
		<div className="absolute g-0  article-auth-container align-items-end d-flex flex-row w-100">
			<div className="img-container  d-flex w-100">
				<div className="row align-items-center justify-content-center  w-100 g-0 z-100">
					<Col xs={11} md={9} lg={8} xl={6} className="">
						<div className="content-container p-4 text-center">{ctaMessage}</div>
					</Col>
				</div>
			</div>
			<style jsx="true">{`
				.z-100 {
					z-index: 100;
				}
				.content-container {
					z-index: 100;
					background: white;
				}
				.img-container {
					height: 75%;

					background: linear-gradient(to right, rgba(20, 37, 65, 1) 25%, rgba(20, 37, 65, 0) 65%),
						url("/img/nurse-bg.png"); /* Use linear-gradient for the gradient and set the opacity values accordingly */
					background-size: cover; /* Set the background image size to cover */
					background-position: top right;
					background-repeat: no-repeat;
				}
				.article-auth-container {
					height: 600px;
					bottom: 0;
					background: linear-gradient(
						to top,
						rgba(255, 255, 255, 1) 80%,
						rgba(255, 255, 255, 0.5) 90%,
						rgba(255, 255, 255, 0) 100%
					); /* Use linear-gradient for the gradient and set the opacity values accordingly */
				}
			`}</style>
		</div>
	);

	return {
		ShowArticleAccessDenied,
		articleAccessClass,
	};
}

function CtaMessage(props) {
	const { title1, withLogin = true, btn1Text, btn1Link, btn2Text, btn2Link } = props;
	return (
		<>
			<Title className="w-100 mb-0" textAlign="center" textJustify="center" element="h3" text={title1} />
			{withLogin && (
				<Title
					className="w-100"
					textAlign="center"
					textJustify="center"
					element="h3"
					text={
						<>
							<LoginLink size="inherit" color={colors.green} href="/login" linkText="Log in" /> to view.
						</>
					}
				/>
			)}
			{(btn1Text || btn2Text) && (
				<Row className="justify-content-center">
					{btn1Text && (
						<Col md={6}>
							<ButtonGroup
								alignButtons="center"
								buttonWidth={{
									md: "12",
								}}
								btn1={{
									text: btn1Text,
									url: btn1Link,
								}}
								button1Variant="yellow"
							/>
						</Col>
					)}
					{btn2Text && (
						<Col md={6}>
							<ButtonGroup
								additionalClasses="mt-1 mt-md-0"
								outlineColor={colors.yellow}
								alignButtons="center"
								buttonWidth={{
									md: "12",
								}}
								btn1={{
									text: btn2Text,
									url: btn2Link,
								}}
								button1Variant="transparent"
							/>
						</Col>
					)}
				</Row>
			)}
		</>
	);
}
